<template>
  <div class="nav" :style="{ left: toLeft, padding: showIndex === '2' ? '0 80px 0 40px' : '0 40px' }">
    <div class="list" v-for="(item, index) in dataList" :key="index">
      <p class="title">{{ item.title }}</p>
      <div class="list_right">
        <div class="list_item" v-for="(ele, ind) in item.children" :key="ind">
          <p
            class="word"
            :class="{ item_title: !e.path, item_active: e.path === $route.path }"
            v-for="(e, i) in ele"
            :key="i"
            @click="changeRouter(e)"
          >
            {{ e.title }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Nav',
  components: {},
  props: {
    showIndex: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      navList: [
        {
          index: '2',
          left: '-140px',
          list: [
            {
              title: '智慧城市',
              children: [[{ title: '数字孪生平台', path: '/product/DigitalTwinPlatform' }]],
            },
            {
              title: '智慧建筑',
              children: [[{ title: 'BIM应用', path: '/product/BIMApplication' }]],
            },
            {
              title: '大数据',
              children: [[{ title: '住建领域标准化数据中台', path: '/product/housingConstruction' }]],
            },
          ],
        },
        {
          index: '3',
          left: '-390px',
          list: [
            {
              title: '服务内容',
              children: [
                [
                  { title: 'GIS数据生产服务', path: '/service/GISData' },
                  { title: '无人机服务', path: '/service/droneService' },
                  { title: 'BIM咨询', path: '/service/BIMConsult' },
                  { title: '沉浸式场景体验', path: '/service/sceneExperience' },
                ],
              ],
            },
          ],
        },
        {
          index: '4',
          left: '-516px',
          list: [
            {
              title: '城市',
              children: [[{ title: 'CIM基础平台', path: '/solution/CIMBasicPlatform' }]],
            },
            {
              title: '行业',
              children: [
                [
                  { title: '智慧住建' },
                  { title: 'BIM全过程监管', path: '/solution/BIMSupervision' },
                  { title: '房屋安全管理', path: '/solution/HouseSecurity' },
                  { title: '房地产监测', path: '/solution/estateMonitoring' },
                  { title: '公房管理', path: '/solution/publicHousing' },
                ],
                [
                  { title: '数字乡村' },
                  { title: '智慧农业', path: '/solution/SmartAgriculture' },
                  { title: '农房监管', path: '/solution/FarmHouseSupervision' },
                  { title: '乡村服务', path: '/solution/ruralService' },
                ],
                [{ title: '智慧执法' }, { title: '智慧执法', path: '/solution/SmartLawEnforcement' }],
                [{ title: '智慧市政' }, { title: '智慧市政', path: '/solution/SmartMunicipal' }],
                [{ title: '智慧交通' }, { title: '智慧交通', path: '/solution/SmartTransportation' }],
              ],
            },
            {
              title: '项目',
              children: [
                [
                  { title: '智慧园区', path: '/solution/SmartIndustrialPark' },
                  { title: '智慧校园', path: '/solution/SmartCampus' },
                  { title: '古建保护', path: '/solution/oldHouse' },
                ],
              ],
            },
          ],
        },
      ],
    }
  },
  computed: {
    dataList() {
      return this.navList.find(e => e.index === this.showIndex).list
    },
    toLeft() {
      return this.navList.find(e => e.index === this.showIndex).left
    },
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {},
  methods: {
    changeRouter(e) {
      if (e.path) this.$router.push(e.path)
    },
  },
}
</script>
<style lang="scss" scoped>
.nav {
  position: absolute;
  background: #ffffff;
  // box-shadow: 0px 10px 29px 2px rgba(7, 107, 212, 0.3);
  padding: 0 40px;
  box-sizing: border-box;
  cursor: auto;
  .list {
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    align-items: center;
    &:first-child {
      .list_right .list_item {
        padding: 48px 0 !important;
      }
    }
    &:last-child {
      .list_right .list_item {
        padding: 48px 0 !important;
      }
    }
    .title {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-style: italic;
      color: #333333;
      position: relative;
      &::after {
        content: '';
        display: block;
        border-top: 3px solid rgba(51, 51, 51, 1);
        border-right: 3px solid rgba(51, 51, 51, 1);
        transform: rotate(45deg);
        width: 7px;
        height: 7px;
        position: absolute;
        top: 50%;
        right: -20px;
        margin-top: -4px;
      }
    }
    .list_right {
      .list_item {
        margin-left: 75px;
        border-bottom: 1px solid #e0e0e0;
        display: flex;
        padding: 30px 0;
        &:last-child {
          border-bottom: none;
        }
        .word {
          width: 115px;
          margin-right: 60px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #3c3c3c;
          text-align: center;
          line-height: 20px !important;
          cursor: pointer;
          &:last-child {
            margin-right: 0px;
          }
        }
        .item_title {
          color: #a4a4a4;
          cursor: auto;
        }
        .item_active {
          color: #2093ff;
        }
      }
    }
  }
}
</style>
